import React, { FC } from 'react';
import { NavMenu, NavMenuLinks, NavMenuTitle, Skeleton } from 'src/common';
import { BidQuestionType } from 'src/models/bids/BidFull/types';
import GroupLinks from '../GroupLinks';
import { useTranslation } from 'react-i18next';
import { useTaskNav } from 'src/models/bids/BidTask/hooks';

const Groups: FC = () => {
  const { t } = useTranslation();
  const { data: nav, loading } = useTaskNav();

  return loading ? (
    <Skeleton loading active />
  ) : nav ? (
    <NavMenu>
      <NavMenuTitle tooltip>{nav.groupName}</NavMenuTitle>
      <NavMenuLinks>
        {nav.type === BidQuestionType.Generated && (
          <>
            <NavMenuTitle>{t('BiddingTool.generatedTasksTitle')}</NavMenuTitle>
            <GroupLinks tasksType={BidQuestionType.Generated} />
          </>
        )}
        <>
          <NavMenuTitle>{t('BiddingTool.manualTasksTitle')}</NavMenuTitle>
          <GroupLinks tasksType={BidQuestionType.Manual} />
        </>
      </NavMenuLinks>
    </NavMenu>
  ) : (
    <></>
  );
};

export default Groups;
